function ICON_CIRCLE_SEWA() {
  return (
    <svg
      id="svg2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9.4639 9.4639"
      fill="none"
      width="9.4639"
      height="9.4639"
    >
      <circle
        id="path3"
        cx="4.7319"
        cy="4.7319"
        r="3.7319"
        fill="#0ca5eb"
        stroke="#dcd9d6"
        strokeLinejoin="round"
        strokeWidth="0"
        style={{ paintOrder: "stroke markers fill" }}
      />
    </svg>
  );
}

export default ICON_CIRCLE_SEWA;
